<template lang="html">
  <section class="app-delete-news">
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to delete.
    </p>
    <div v-else>
      <div v-if="!confirmDeletion">
        <p class="text-danger">
          Do you really want to delete "<strong><em>{{ getCurrentElement.title }}</em></strong>"
          ({{getCurrentElement.id}}) from your <strong>{{ getComponent }}</strong> list ?
        </p>
        <div class="mt-4 mb-4 text-center">
          <button type="button" @click="onSubmit" class="btn btn-danger">Yes</button>
          <button type="button" @click="navigateAway('read')" class="btn btn-success ml-3">No</button>
        </div>
      </div>
      <div v-else>
        <p class="text-success">
          <strong>{{ messageSubmission }}</strong>
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'DeleteNews',
  props: [],
  mounted () {},
  data () {
    return {
      confirmDeletion : false,
      messageSubmission : ''
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setPreviousOperation',
      'setCrudComponent',
      'setCurrentElement',
      'deleteData'
    ]),
    onSubmit() {
      const formData = {
        news_id : (this.getCurrentElement) ? this.getCurrentElement.id : ''
      };
      this.deleteData(formData)
        .then(data => {
          this.confirmDeletion = true;
          this.messageSubmission = data;
          setTimeout( () => this.setCurrentElement(null) , 5000);
        })
        .catch()
    },
    navigateAway(tab) {
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getOperation',
      'getPreviousOperation',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-delete-news {}
</style>



// WEBPACK FOOTER //
// src/components/news/DeleteNews.vue